import { LiveSourceTypes } from '@/enum/liveSourceTypes';

export const isSourceTypeValid = (sourceType: string): boolean => sourceType in LiveSourceTypes;
